module.exports = __webpack_public_path__ + "static/img/pic_coop01@2x.40b72d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/brandOperation/serviceContent/pic_coop01@2x.png
// module id = Btjb
// module chunks = 0